/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-02-22 11:41:27
 * @LastEditors: changfeng
 * @LastEditTime: 2023-05-04 14:08:38
 */
export default {
  'campaign.title': 'campaign',
  'campaign.create.new': 'new campaign ',
  'campaign.select': 'Use existing',
  'campaign.select.exiting': 'Choose a campaign',
  'campaign.name': 'Campaign name',
  'campaign.set campaign budget': 'budget',
  'campaign.set campaign budget on': 'Campaign budget optimization',

  'campaign.create success': 'Successfully created',
  'campaign.budget.day': 'Daily budget',
  'campaign.budget.total': 'General budget',
  'campaign.budget.placeholder': 'above 50.00',

  'campaign.form.message.adAccount': 'please choose account',
  'campaign.form.message.please choose campaign': 'please choose campaign',
  'campaign.form.message.budget': 'Please enter a number not less than 50',
};
